import React, { useState,useEffect} from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import {addNewSales } from "../api/sales";
import {getDropdownsales,getDropdownchannel} from "../api/auth";
import Dropdown from '../components/Dropdown'
type SalesOffice = {
  sales_office_id: string;
  name: string;
};
type Channel = {
  channel_id: string;
  name: string;
};

const AddSales = () => {
  const [formData, setFormData] = useState({
    channel_id: [],
    // channelid: "",
    // territory_identifier: "",
    persona:"",
    checkin_radius:"",
    max_unplanned_visits:"",
    min_canton_qty:"",
    // emp_id: "",
    // sales_office_id: "",
    sales_office_id: [],
 
  });
  const [sales_office_id, setValues] = useState<SalesOffice[]>([]);
  const [loading, setLoading] = useState(false);
   const [valuesChannel, setValuesChannel] = useState<Channel[]>([]);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setFormData({
      
      channel_id: formData.channel_id,
      checkin_radius: formData.checkin_radius || "",
      sales_office_id: formData.sales_office_id,
      //  sales_office_id: formData.sales_office_id || "",
        persona: formData.persona || "",
        max_unplanned_visits: formData.max_unplanned_visits || "",
        min_canton_qty: formData.min_canton_qty || "",
        
        
      });
    try {
      setLoading(true);
      // const emptyFields = Object.entries(formData)
      //   .filter(([_, value]) => value === null || value === "")
      //   .map(([key]) => key);

      // setInvalidFields(emptyFields);

      // if (emptyFields.length > 0) {
      //   toast.error("Please fill all required fields.");
      //   return;
      // }

      setInvalidFields([]);
      const response = await addNewSales(formData);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.SALES);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch territory data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error(error.response.data.detail,{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      const fetchMappings = async () => {
        try {
          const res = await getDropdownsales();
          if (!res) {
            toast.error("No data received or malformed response");
            console.warn("No data received or malformed response:", res);
            return;
          }
          setValues(res.sales_offices || []);
        } catch (error: any) {
          console.error("Failed to fetch data:", error);
          if (error?.response?.status === 404) {
            toast.error("Route not found, Please try again later");
          } else if (error?.response?.status === 500) {
            toast.error("Error while fetching");
          } else {
            const detail = error?.response?.data?.detail;
            if (Array.isArray(detail)) {
              detail.forEach((err) => toast.error(err.msg));
            } else {
              toast.error(
                detail?.msg || detail || "An unexpected error occurred."
              );
            }
          }
        } finally {
          setLoading(false);
        }
      };
  
      fetchMappings();
    }, []);
    const channelOptions = valuesChannel.map((channel) => ({
      value: channel.channel_id,
      name: channel.name,
    }));
    const options = sales_office_id.map((office) => ({
      value: office.sales_office_id,
      name: office.name,
    }));
    const handleChangeDropdown = (e: any) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
    useEffect(() => {
      const fetchMappings = async () => {
        try {
          const res = await getDropdownchannel();
          if (!res) {
            toast.error("No data received or malformed response");
            console.warn("No data received or malformed response:", res);
            return;
          }
  
          setValuesChannel(res.channels || []);
        } catch (error: any) {
          console.error("Failed to fetch employee data:", error);
          if (error?.response?.status === 404) {
            toast.error("Route not found, Please try again later");
          } else if (error?.response?.status === 500) {
            toast.error("Error while fetching the employee");
          } else {
            const detail = error?.response?.data?.detail;
            if (Array.isArray(detail)) {
              detail.forEach((err) => toast.error(err.msg));
            } else {
              toast.error(
                detail?.msg || detail || "An unexpected error occurred."
              );
            }
          }
        } finally {
          setLoading(false);
        }
      };
  
      fetchMappings();
    }, []);
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Add Sales Rule</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
      <div className="my-2">
          <label className="block font-semibold mb-1">Channel ID</label>
          {/* <input name="channelid" 
          type="text"
          onChange={handleChange}
           value={formData.channelid} 
                className={getInputClass("channelid")}
                placeholder="Channel ID"
                /> */}

<Dropdown
            name="channel_id"
            value={formData.channel_id}
            onChange={handleChangeDropdown}
            options={channelOptions}
            className={getInputClass("channel_id")}
            placeholder="Select Channel Id"
            searchable={true}
           
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Max Unplanned Visits  </label>
          <input
            type="text"
            name="max_unplanned_visits"
           
            value={formData.max_unplanned_visits}
            onChange={handleChange}
            className={getInputClass("max_unplanned_visits")}
            placeholder="Max Unplanned Visits"
          />
        </div>
        <div className="my-2">
          <label className="block font-semibold mb-1">Checkin Radius  </label>
          <input
            type="text"
            name="checkin_radius"
           
            value={formData.checkin_radius}
            onChange={handleChange}
            className={getInputClass("checkin_radius")}
            placeholder="Checkin Radius"
          />
        </div>
        <div className="my-2">
          <label className="block font-semibold mb-1">Min Canton Qty  </label>
          <input
            type="text"
            name="min_canton_qty"
            
            value={formData.min_canton_qty}
            onChange={handleChange}
            className={getInputClass("min_canton_qty")}
            placeholder="Min Canton Qty"
          />
        </div>
      
        <div className="my-2">
          <label className="block font-semibold mb-1">Sales Office Id </label>
          {/* <input
            type="text"
            name="sales_office_id"
         
            value={formData.sales_office_id}
            onChange={handleChange}
            className={getInputClass("sales_office_id")}
            placeholder="Sales Office Id"
          /> */}
           <Dropdown
            name="sales_office_id"
            value={formData.sales_office_id}
            onChange={handleChangeDropdown}
            options={options}
            className={getInputClass("sales_office_id")}
            placeholder="Select Sales Office"
            searchable={true}
          
          />
        </div>

        <div>
    <label className="block font-semibold mb-1">Persona</label>


<select
  name="persona"
  value={formData.persona}
  onClick={(e) => e.stopPropagation()}
  onChange={handleChange}
  className={getInputClass("persona")}
>
  <option value="" disabled hidden>Persona</option>
  <option value="Salesman">Salesman</option>
  <option value="Preseller">Preseller</option>
</select>

  </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2 mt-5"
        >
          Add Sales Rule {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default AddSales;
